import _authConfig from "./auth-config.json"

export interface AuthConfig {
    consumerKey: string
    consumerSecret: string
}

export const authConfig: AuthConfig = _authConfig
